<!--
 * @Author: qx
 * @Date: 2021-07-23 10:03:54
 * @LastEditTime: 2021-08-16 13:41:31
 * @LastEditors: 汪俊洪
 * @Description: 发票
-->
<template>
  <div class="invoice-list-lclb">
    <!--  -->
    <el-dialog
      title="发票信息"
      :visible.sync="invoiceVisible"
      :show-close="false"
      width="700px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="dataForm"
        :rules="dataFormRules"
        ref="invoiceForm"
        label-position="right"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item
              label="发票类型："
              prop="invoiceType"
            >
              <el-radio-group v-model="dataForm.invoiceType">
                <el-radio label="10">普通发票</el-radio>
                <el-radio label="20">专用发票</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="开票对象："
              prop="invoiceObjType"
            >
              <el-radio-group v-model="dataForm.invoiceObjType">
                <el-radio label="10">个人</el-radio>
                <el-radio label="20">单位</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item
              label=""
              prop="invoiceType"
            >
              <el-checkbox
                v-model="dataForm.defaultFlag"
                true-label="10"
                false-label=''
              >
                默认发票
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="发票抬头"
              prop="companyName"
            >
              <el-input
                v-model="dataForm.companyName"
                :maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="税务登记证号"
              prop="taxpayerIdentity"
            >
              <el-input
                v-model="dataForm.taxpayerIdentity"
                maxlength="40"
                placeholder=""
                @input="dataForm.taxpayerIdentity=dataForm.taxpayerIdentity.replace(/[^A-Za-z0-9]/g,'')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="基本开户账号"
              prop="bankAccountNo"
              :rules="dataForm.invoiceType === '20' ? dataFormRules.bankAccountNo : [{ required: false, message: '', trigger: 'blur' }]"
            >
              <el-input
                v-model="dataForm.bankAccountNo"
                oninput="value=value.replace(/[^0-9]/g,'')"
                :maxlength="32"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="注册固定电话"
              prop="companyPhone"
              :rules="dataForm.invoiceType === '20' ? dataFormRules.companyPhone : []"
            >
              <el-input
                v-model="dataForm.companyPhone"
                @input="phoneInput"
                :maxlength="40"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="开户银行名称"
              prop="openingBank"
              :rules="dataForm.invoiceType === '20' ? dataFormRules.openingBank : []"
            >
              <el-input
                v-model="dataForm.openingBank"
                :maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="注册场所地址"
              prop="companyAddress"
              :rules="dataForm.invoiceType === '20' ? dataFormRules.companyAddress : []"
            >
              <el-input
                v-model="dataForm.companyAddress"
                :maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="发票收货人"
              prop="consignee"
            >
              <el-input
                v-model="dataForm.consignee"
                :maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="发票收货人电话"
              prop="contactInformation"
            >
              <el-input
                v-model="dataForm.contactInformation"
                oninput="value=value.replace(/[^0-9]/g,'')"
                :maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="发票邮寄地址"
              prop="mailingAddress"
            >
              <el-input
                v-model="dataForm.mailingAddress"
                :maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="closeHandle()"
          :loading="loading"
        >取 消</el-button>
        <el-button
          type="primary"
          @click="saveHandle()"
          :loading="loading"
        >保 存</el-button>
      </div>
    </el-dialog>
    <div class="title">发票信息</div>
    <el-table
      ref="apyTable"
      :data="invoiceList"
      width="100%"
      max-height="300px"
      size="small"
      border
      highlight-current-row
    >
      <el-table-column
        label="选择"
        center
        width="50"
      >
        <template slot-scope="{row}">
          <el-radio
            v-model="currentId"
            :label="row.invoiceId"
            @change="changeHadle"
            aria-checked="true"
          >&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="发票抬头"
        header-align="center"
        width="200"
      >
        <template slot-scope="{row}">
          <span :label="row.companyName">{{row.companyName}}</span>
          <span
            v-if="row.defaultFlag === '10'"
            class="default-flag"
          >默认</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="invoiceType"
        label="发票类型"
        align="center"
        width="150"
      >
        <template slot-scope="{row}">
          {{row.invoiceType === '10' ? '普通发票' : '专用发票'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="invoiceObjType"
        label="开票对象"
        align="center"
      >
        <template slot-scope="{row}">
          {{row.invoiceObjType === '10' ? '个人' : '单位'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="taxpayerIdentity"
        label="税务登记证号"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="bankAccountNo"
        label="基本开户账号"
        align="center"
        width="160"
      ></el-table-column>
      <el-table-column
        prop="companyPhone"
        label="固定电话"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="openingBank"
        label="开户银行名称"
        align="center"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="companyAddress"
        label="注册场所地址"
        header-align="center"
        width="200"
      ></el-table-column>
      <el-table-column
        prop=""
        min-width="200"
        label="收票人/联系人/地址"
      >
        <template slot-scope="{row}">
          {{(row.consignee || '') + '/' + (row.contactInformation || '') + '/' + (row.mailingAddress || '')}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="100"
      >
        <template slot-scope="{row}">
          <el-button
            @click="editHandle(row)"
            type="text"
            :loading="loading"
            size="small"
          >编辑</el-button>
          <el-button
            @click="deleteHandle(row)"
            type="text"
            :loading="loading"
            size="small"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增发票 -->
    <el-row class="margin-top">
      <el-col
        :span="24"
        style="text-align: right;"
      >
        <el-button
          class="addBut"
          icon="el-icon-plus"
          :loading="loading"
          @click="editHandle"
        >新增发票</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'invoiceList',
  components: {},
  // mixins: [],
  props: {
    // 发票列表
    // invoiceList: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   }
    // },
    // 当前选中的id
    chooseId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentId: '',
      invoiceList: [],
      invoiceVisible: false,
      loading: false,
      invoiceId: '',
      dataForm: {
        invoiceType: '10', // 发票类型 10普通 ；20专票
        invoiceObjId: '', // 开票对象10 用户id 20 公司id
        invoiceObjType: '10', // 开票对象 10个人；20单位
        defaultFlag: '', // 是否默认发票
        companyName: '', // 发票抬头
        taxpayerIdentity: '', // 税务登记证号
        bankAccountNo: '', // 基本开户账号
        companyPhone: '', // 注册固定电话
        openingBank: '', // 开户银行名称
        companyAddress: '', // 注册场所地址
        consignee: '', // 发票收货人
        contactInformation: '', // 发票收货人电话
        mailingAddress: '', // 发票邮寄地址
        remarks: ''
      }
    }
  },
  computed: {
    companyId () {
      return this.$store.state.user.defaultCompanyId
    },
    dataFormRules () {
      return {
        invoiceType: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        invoiceObjType: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        companyName: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        taxpayerIdentity: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        bankAccountNo: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        companyAddress: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        companyPhone: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        openingBank: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    chooseId (val) {
      this.currentId = val
    }
  },
  mounted () {
    this.getInvoicList()
  },
  methods: {
    changeHadle (val) {
      this.$emit('change', val)
    },
    // 固话
    phoneInput (val) {
      val = val.replace(/[^0-9-]/g, '')
      const index1 = val.indexOf('-')
      if (index1 > -1 && val.length !== (index1 + 1) && val.indexOf('-', index1 + 1)) {
        const endStr = val.substr(index1 + 1).replace(/[-]/g, '')
        this.dataForm.companyPhone = val.substr(0, index1 + 1) + endStr
      } else {
        this.dataForm.companyPhone = val
      }
    },
    // 获取发票列表
    getInvoicList () {
      if (!this.companyId) {
        this.invoiceList = []
        return false
      }
      this.$request
        .get(
          `/front/consumer/order/payinvoice/selectUserAllInvoiceList?companyId=${this.companyId}`
        )
        .then((res) => {
          this.invoiceList = res || []
          if (this.currentId) {
            let invoiceInfo = this.invoiceList.find((item) => {
              return item.invoiceId === this.currentId
            })
            if (!invoiceInfo) {
              this.currentId = ''
            }
          }
          if (!this.currentId && this.invoiceList.length) {
            let invoiceInfo = this.invoiceList.find((item) => {
              return item.defaultFlag === '10'
            })
            if (invoiceInfo) {
              this.currentId = invoiceInfo.invoiceId
            } else {
              this.currentId = ''
            }
          }
          this.$emit('change', this.currentId)
        })
        .catch()
    },
    // 删除发票
    deleteHandle (row) {
      this.$confirm('此操作将永久删除该发票?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.$http
            .post(`/front/consumer/order/payinvoice/delete`, [row.invoiceId])
            .then(({ data }) => {
              if (data.code !== 0) {
                return false
              }
              this.getInvoicList()
            })
        })
        .catch(() => {})
    },
    // 打开新增发票
    // invoiceAddHandle () {}
    // 编辑
    editHandle (row = {}) {
      if (this.$refs['invoiceForm']) {
        this.$refs['invoiceForm'].resetFields()
      }
      this.invoiceId = row.invoiceId || ''
      this.dataForm = {
        invoiceType: row.invoiceType || '10', // 发票类型 10普通 ；20专票
        invoiceObjType: row.invoiceObjType || '10', // 开票对象 10个人；20单位
        invoiceObjId: row.invoiceObjId || '', // 开票对象10 用户id 20 公司id
        defaultFlag: row.defaultFlag || '', // 是否默认发票
        companyName: row.companyName || '', // 发票抬头
        taxpayerIdentity: row.taxpayerIdentity || '', // 税务登记证号
        bankAccountNo: row.bankAccountNo || '', // 基本开户账号
        companyPhone: row.companyPhone || '', // 注册固定电话
        openingBank: row.openingBank || '', // 开户银行名称
        companyAddress: row.companyAddress || '', // 注册场所地址
        consignee: row.consignee || '', // 发票收货人
        contactInformation: row.contactInformation || '', // 发票收货人电话
        mailingAddress: row.mailingAddress || '', // 发票邮寄地址
        remarks: ''
      }
      this.invoiceVisible = true
    },
    // 关闭
    closeHandle () {
      this.invoiceVisible = false
    },
    // 保存
    saveHandle () {
      if (this.loading) {
        return false
      }
      this.$refs['invoiceForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.loading = true
        let params = Object.assign({}, this.dataForm)
        if (this.invoiceId) {
          params.invoiceId = this.invoiceId
        }
        if (params.invoiceObjType === '10') {
          params.invoiceObjId = ''
        } else {
          params.invoiceObjId = this.companyId
        }
        params.companyId = this.companyId
        // this.invoiceForm.defaultFlag = this.invoiceForm.flagAdd ? '10' : '20'
        this.$http
          .post(
            `/front/consumer/order/payinvoice/${
              this.invoiceId ? 'update' : 'save'
            }`,
            params
          )
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.$message.success(res.message)
            this.closeHandle()
            this.getInvoicList()
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.invoice-list-lclb {
  .title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .margin-top {
    margin-top: 20px;
  }
  .addBut {
    display: inline-block;
    width: 130px;
    box-sizing: border-box;
    border: 1px solid #1d65a8;
    color: #1d65a8;
    text-align: center;
    font-size: 16px;
    user-select: none;
    cursor: pointer;
    z-index: 666;
  }
  .default-flag {
    display: inline-block;
    width: 35px;
    height: 20px;
    line-height: 20px;
    background: #1d65a8;
    color: #ffffff;
    font-weight: normal;
    font-size: 12px;
    text-align: center;
    margin-left: 20px;
  }
}
</style>
